import React, { ReactElement, ReactNode, memo, useMemo, useState } from 'react';
import { Button, Table } from 'tea-component';
import _ from 'lodash-es';
import Loading from '@/pages/datalab/components/Loading';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import './index.scss';

const { sortable, scrollable } = Table.addons;
interface DropChildProps {
  tableData: {
    addonscolumns: Array<string>;
    cvmList: any;
    columns: any;
  };
  children: ReactNode;
  className: string | undefined;
  loading: boolean;
  error: any;
  messages: any;
  chatLoading: any;
  isErrorRetry: (...args: any) => void;
  OnClickTableSort: (...args: any) => void;
  [key: string]: unknown;
}
const Text2SQLtable = memo((props: Partial<DropChildProps>): ReactElement => {
  const {
    tableData,
    OnClickTableSort,
    loading,
    className,
    error,
    chatLoading, messages,
    isErrorRetry,
    ...restProps
  } = props;
  const [sorts, setSorts] = useState<any>([]);
  const { formatMessage, } = useAigcIntl("text2sql");
  const loadingOrNodata = tableData?.cvmList.length === 0 || loading;
  const renderComponents = useMemo(() => {
    if (chatLoading || messages?.length <= 1) {
      return formatMessage("empty");
    }
    if (_.isEmpty(tableData?.cvmList)) {
      return formatMessage('no_data');
    }

    if (error || error?.code === -1) {
      return <Button
        type="primary"
        onClick={isErrorRetry}
      >
        {formatMessage("table_rebuild")}
      </Button>;
    }

  }, [chatLoading, error, formatMessage, isErrorRetry, loading, messages?.length, tableData?.cvmList]);
  return (
    <div style={{ position: 'relative', }}>
      {/* 添加覆盖NoData，不随表格滚动 */}
      <div
        style={{
          display: loadingOrNodata ? 'block' : 'none',
          position: 'absolute',
          width: '-webkit-fill-available',
          zIndex: 9999,
          textAlign: 'center',
          bottom: '-90px',
        }}
      >
        {renderComponents}
      </div>
      <Loading loading={loading} style={{ marginTop: '0' }} >
        <Table
          className={'dbo-aigc-table'}
          bordered={false}
          records={
            loading
              ? []
              : [...(tableData?.cvmList || [])].sort(sortable.comparer(sorts))
          }
          columns={tableData?.columns}
          addons={[
            // 这里有bug，虚拟滚动，暂不开启,暂时没有方案处理
            // scrollable({
            //     virtualizedOptions: {
            //         height: 138,
            //         itemHeight: 46,
            //         onScrollBottom: () => console.log('Bottom'),
            //     },
            // }),
            scrollable({
              maxHeight: 138,
              minWidth: 1200,
            }),
          ]}
          {...restProps}
        />
      </Loading >
    </div>
  );
});

export default Text2SQLtable;
